import React from "react";
import styled from "styled-components";

interface Props {
	markOnly?: boolean;
	className?: string;
}

const Frame = styled.svg`
	height: 30px;
	.st0 {
		fill: #e50012;
	}
	.st1 {
		fill: #010e3d;
	}
`;
const Logo: React.FC<Props> = ({ markOnly = false, className }) => {
	return (
		<Frame viewBox="0 0 365 30" className={className}>
			<g className="mark">
				<path
					className="st0"
					d="M50.8,4.9H48c-0.1,0-0.1,0.1-0.1,0.1v3.5v4.7v0.2c0,0.1-0.1,0.1-0.1,0.1h-7c-0.1,0-0.1-0.1-0.1-0.1v-0.2V8.5
          V5.2C40.7,5,40.6,5,40.6,5h-2.8c-0.1,0-0.1,0.1-0.1,0.1v19.9c0,0.1,0.1,0.1,0.1,0.1h2.8c0.1,0,0.1-0.1,0.1-0.1v-3.2v-5l0,0
          c0-0.1,0.1-0.1,0.1-0.1h7c0.1,0,0.1,0.1,0.1,0.1l0,0v4.9V25c0,0.1,0.1,0.1,0.1,0.1h2.8c0.1,0,0.1-0.1,0.1-0.1V5.2
          C50.9,5,50.9,4.9,50.8,4.9"
				/>
				<path
					className="st0"
					d="M88.8,0L88.8,0H59.4H54v24.6v0.2c0,0,0,0.4-0.4,0l-1.6-1.6c0,0-0.1-0.1-0.1,0V26v0.7l3.2,3.2H59L88.8,0.2l0,0
          V0z M83.6,2.5L83.6,2.5c-0.1,0.1-23.9,23.9-24,24s-0.1,0-0.1,0v-0.1V7.9V2.5c0-0.1,0.1-0.1,0.1-0.1H60h23.6
          C83.8,2.3,83.6,2.5,83.6,2.5"
				/>
				<path
					className="st0"
					d="M33.1,0L33.1,0h-3.8H0v0.2l0,0L29,30h5.4V5.4V5.3c0,0,0-0.4,0.4,0l1.6,1.6c0,0,0.1,0.1,0.1,0V4.1V3.4L33.1,0z
           M29,7.9v18.5v0.1c0,0,0,0.1-0.1,0S5,2.6,5,2.6L4.9,2.5c0,0-0.1-0.1,0.1-0.1h23.6H29c0,0,0.1,0,0.1,0.1v5.4H29z"
				/>
			</g>
			{!markOnly && (
				<g className="companyName">
					<path
						className="st1"
						d="M101.6,17.8V6.1h1.6v14.5h-1.3L92.5,8.8v11.9h-1.6V6.1h1.6L101.6,17.8z"
					/>
					<path
						className="st1"
						d="M114.2,6l6.6,14.6H119l-1.7-3.8h-7.9l-1.7,3.8H106L112.6,6C112.6,6,114.2,6,114.2,6z M116.6,15.4l-3.2-7.4
          l-3.4,7.4H116.6z"
					/>
					<path
						className="st1"
						d="M129.4,12.5l6.5,8.2h-2l-5.5-7l-3.1,3.1v3.8h-1.7V6.1h1.7v8.6l8.3-8.6h2.2L129.4,12.5z"
					/>
					<path
						className="st1"
						d="M145.3,6l6.6,14.6h-1.8l-1.7-3.8h-7.9l-1.7,3.8h-1.7L143.7,6C143.7,6,145.3,6,145.3,6z M147.8,15.4l-3.2-7.4
          l-3.4,7.4H147.8z"
					/>
					<path
						className="st1"
						d="M164.7,14.2h-8.4v6.5h-1.7V6.1h1.7v6.5h8.4V6.1h1.7v14.5h-1.7V14.2z"
					/>
					<path
						className="st1"
						d="M177.3,6l6.6,14.6h-1.8l-1.7-3.8h-7.9l-1.7,3.8h-1.7L175.8,6C175.8,6,177.3,6,177.3,6z M179.8,15.4l-3.2-7.4
          l-3.4,7.4H179.8z"
					/>
					<path
						className="st1"
						d="M187.8,9.7c0,0.7,0.2,1.3,0.8,1.7c0.6,0.4,1.6,0.8,3.1,1.1c1.7,0.4,2.9,0.8,3.6,1.4c0.7,0.6,1.1,1.6,1.1,2.6
          c0,1.2-0.5,2.3-1.4,3c-1,0.7-2.2,1.1-3.6,1.1c-2.3,0-4.2-0.7-5.9-2.3l1-1.2c0.7,0.7,1.6,1.2,2.3,1.6c0.7,0.4,1.7,0.5,2.6,0.5
          c1,0,1.8-0.2,2.3-0.7c0.6-0.5,0.8-1.1,0.8-1.8c0-0.7-0.2-1.3-0.8-1.7c-0.5-0.4-1.6-0.7-3-1.1c-1.7-0.4-3-0.8-3.7-1.6
          c-0.7-0.6-1.2-1.6-1.2-2.6c0-1.2,0.5-2.2,1.3-2.9c0.8-0.7,2-1.1,3.4-1.1c1.9,0,3.6,0.6,5,1.8l-1,1.3c-1.3-1.1-2.6-1.6-4.2-1.6
          c-1,0-1.7,0.2-2.3,0.7C188,8.5,187.8,9.1,187.8,9.7z"
					/>
					<path
						className="st1"
						d="M209.7,14.2h-8.4v6.5h-1.7V6.1h1.7v6.5h8.4V6.1h1.7v14.5h-1.7V14.2z"
					/>
					<path className="st1" d="M215.6,6.1h1.7v14.5h-1.7V6.1z" />
					<path
						className="st1"
						d="M240,8.9l-5.3,7.8h-0.1L229.3,9v11.8h-1.6V6.1h1.7l5.3,7.9l5.3-7.9h1.7v14.5H240L240,8.9L240,8.9z"
					/>
					<path
						className="st1"
						d="M256,6.1v1.6h-8.8v5.2h7.8v1.4h-7.8v6.4h-1.7V6.1H256z"
					/>
					<path
						className="st1"
						d="M271.4,18.6c-1.7,1.4-3.6,2.2-5.8,2.2c-2.3,0-4-0.7-5.4-2.2c-1.3-1.4-2-3.2-2-5.3s0.7-3.8,2-5.3
          s3.1-2.2,5.3-2.2c1.2,0,2.2,0.1,3,0.5c0.8,0.4,1.7,0.8,2.4,1.4L269.8,9c-1.3-1.1-2.8-1.7-4.4-1.7c-1.6,0-2.9,0.6-4,1.7
          c-1.1,1.2-1.6,2.5-1.6,4.2c0,1.8,0.5,3.2,1.6,4.3c1.1,1.1,2.4,1.7,4.2,1.7c1.6,0,3-0.5,4.2-1.4v-3.6h-4.4v-1.4h6V18.6z"
					/>
					<path className="st1" d="M276.6,20.6h-1.9v-2.2h1.9V20.6z" />
					<path
						className="st1"
						d="M298.8,18.4c-0.8,0.8-1.7,1.4-2.6,1.9c-0.8,0.5-1.9,0.6-3.2,0.6c-2,0-3.8-0.7-5.2-2.2c-1.3-1.4-2-3.2-2-5.3
          s0.7-3.8,2-5.3c1.4-1.4,3.1-2.2,5.3-2.2c1.2,0,2.3,0.2,3.1,0.6c0.8,0.4,1.7,1,2.5,1.7l-1.1,1.2c-1.4-1.3-2.9-2-4.6-2
          c-1.6,0-2.9,0.6-4,1.7c-1.1,1.1-1.6,2.5-1.6,4.2s0.5,3.1,1.6,4.3c1.1,1.2,2.4,1.7,4,1.7c1,0,1.8-0.1,2.5-0.5
          c0.7-0.4,1.4-0.8,2.2-1.6L298.8,18.4z"
					/>
					<path
						className="st1"
						d="M313.3,8c1.3,1.4,2,3.2,2,5.3s-0.7,3.8-2,5.3c-1.4,1.4-3.1,2.2-5.3,2.2s-4-0.7-5.3-2.2c-1.3-1.4-2-3.2-2-5.3
          s0.7-3.8,2-5.3c1.4-1.4,3.1-2.2,5.3-2.2C310.2,5.9,312,6.6,313.3,8z M312.1,17.6c1.1-1.2,1.6-2.5,1.6-4.2s-0.6-3.1-1.7-4.2
          c-1.1-1.2-2.4-1.8-4.1-1.8s-3,0.6-4.1,1.7c-1.1,1.2-1.6,2.5-1.6,4.2s0.6,3.1,1.7,4.2c1.1,1.2,2.4,1.8,4.1,1.8
          C309.7,19.3,311,18.8,312.1,17.6z"
					/>
					<path className="st1" d="M319.4,20.6h-1.9v-2.2h1.9V20.6z" />
					<path
						className="st1"
						d="M321.9,22.4c1-0.4,1.4-1,1.4-1.8h-0.7v-2.2h1.9v1.9c0,0.8-0.2,1.4-0.6,1.9s-1,0.7-1.8,1L321.9,22.4z"
					/>
					<path
						className="st1"
						d="M328.2,20.6V6.1h1.7v13h8.2v1.6C338,20.6,328.2,20.6,328.2,20.6z"
					/>
					<path
						className="st1"
						d="M344.4,7.7v13h-1.7v-13h-4.9V6.1h11.4v1.6H344.4z"
					/>
					<path
						className="st1"
						d="M362.8,8.2c1.4,1.3,2.2,3.1,2.2,5.2s-0.7,3.8-2.2,5.2c-1.4,1.4-3.2,2-5.5,2h-5V6.1h5
          C359.6,6.1,361.4,6.8,362.8,8.2z M361.6,17.5c1.1-1.1,1.7-2.4,1.7-4.1s-0.6-3-1.7-4.1s-2.5-1.7-4.3-1.7H354v11.5h3.4
          C359.1,19.1,360.6,18.6,361.6,17.5z"
					/>
				</g>
			)}
		</Frame>
	);
};

export default styled(Logo)``;
